<template>
  <BaseStepperDialog
    :dialogSettings="dialogSettings"
    :totalSteps="4"
    :isSaving="isSaving"
    @onStepsUpdate="handleStepUpdate"
    @onSave="handleSave"
    @onClose="handleClose"
  >
    <template v-slot>
      <div class="dialog__form container col-lg-6 col-sm-12 mt-6">
        <div v-show="currentStep === 1">
          <h2>Which proof of your right to work in the UK do you have?</h2>
          <RadioButton
            @select="handleRadioChange"
            :selected-value="rtwType"
            :options="typeOptions"
          />
          <ExtendedOptions
            v-if="showExtendedOption"
            :extendedAnswers="extendedAnswers"
            @change="extendedAnswersChange"
          />
        </div>
        <div v-show="currentStep === 2">
          <h2 class="mb-4">When does your {{ rtwType }} expire?</h2>
          <DatePicker label="Document Expiry Date" />
        </div>
        <div v-show="currentStep === 3">
          <h2>Upload a photo of your {{ rtwType }}</h2>
          <!-- WIP will update component when api is available -->
          <UploadDocument :compliance="compliance" />
        </div>
        <div v-show="currentStep === 4">
          <h2>
            You don’t have sufficient evidence of your right to work in the UK
          </h2>
          <label class="mt-4">
            Please say why you have the right to work in the UK and what
            evidence you can provide
          </label>
          <v-textarea />
        </div>
      </div>
    </template>
  </BaseStepperDialog>
</template>

<script>
import BaseStepperDialog from "@/components/common/BaseStepperDialog";
import RadioButton from "@/components/common/RadioButton";
import { RTW_TYPES, RTW_NAMES } from "@/constants/offers";
import { BOOLEAN_OPTIONS } from "@/constants/common";
import UploadDocument from "@/views/offers/components/compliances/forms/UploadDocument";
import ExtendedOptions from "@/views/offers/components/compliances/forms/rightToWork/ExtendedOptions";
import DatePicker from "@/components/common/DatePicker";

const { NONE } = RTW_NAMES;
export default {
  props: {
    dialogSettings: Object,
    compliance: Object
  },
  components: {
    BaseStepperDialog,
    RadioButton,
    UploadDocument,
    DatePicker,
    ExtendedOptions
  },
  data() {
    return {
      currentStep: 1,
      typeOptions: RTW_TYPES,
      updateServiceOptions: BOOLEAN_OPTIONS,
      isSaving: false,
      rtwType: null,
      extendedAnswers: {
        hasOutstandingAppeal: false,
        isAllowedToWork: false
      },
      updateService: false
    };
  },
  computed: {
    showExtendedOption() {
      return this.rtwType === NONE;
    }
  },
  methods: {
    handleRadioChange(selectedValue) {
      this.rtwType = selectedValue;
    },
    handleStepUpdate(currentStep) {
      this.currentStep = currentStep;
    },
    handleUpdateServiceChange(selectedValue) {
      this.updateService = selectedValue;
    },
    extendedAnswersChange(answers) {
      this.extendedAnswers = answers;
    },
    handleSave() {
      // WIP
      this.isSaving = true;
    },
    handleClose() {
      this.isSaving = false;
      this.currentStep = 1;
    }
  }
};
</script>
